<template>
  <v-card elevation="0" class="my-0">
    <div class="text-center">
      <v-tooltip bottom v-for="item in recibos" :key="item.id" class="">
        <template #activator="{ on, attrs }">
          <v-btn
            class="mr-2 my-1"
            :color="item.editable ? 'amber' : item.estado ? 'primary' : 'red'"
            v-bind="attrs"
            v-on="on"
            rounded
            @click="item.editable ? openEditReciboTable(item) : openDialogShow(item)"
          >
            <span class="font-weight-bold mr-2">{{ `00${item.numero_recibo}` }}</span> <v-icon> mdi-eye</v-icon>
          </v-btn>
        </template>
        Ver Recibo
      </v-tooltip>
    </div>
    <show ref="refDetail">
      <template v-slot:morebuttons v-if="tienepermiso">
        <v-btn color="success" v-if="puedeEditar" rounded small @click="openEditDialog(recibo)">
          <v-icon class="mr-1"> mdi-notebook-edit</v-icon> Editar
        </v-btn>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn color="black" class="ml-2" outlined rounded small v-bind="attrs" @click="cancelRecibo" v-on="on">
              <v-icon class="mr-1"> mdi-file-cancel</v-icon> anular
            </v-btn>
          </template>
          Anular Recibo
        </v-tooltip>
      </template>
    </show>
    <edit-recibo @closeDialog="eventCloseDialog" ref="refEditRecibo"></edit-recibo>
    <edit-recibo-table @closeDialog="eventCloseDialog" ref="refEditReciboTable"></edit-recibo-table>
  </v-card>
</template>

<script>
  import xaxios from '@/xaxios';
  import Show from '../recibos/Show.vue';
  import EditRecibo from './EditRecibo.vue';
  import EditReciboTable from './EditReciboTable.vue';
  export default {
    components: { Show, EditRecibo, EditReciboTable },
    props: { RecibosGenerados: { type: Array, default: () => [] }, PlanPagos: { type: Array, default: () => [] } },
    data() {
      return {
        recibos: [],
        recibo: null,
        today: null,
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
      };
    },
    computed: {
      puedeEditar() {
        if (!this.recibo) {
          return false;
        }
        return this.PlanPagos.length && this.$store.state.CARGO.id == 1;
      },
      tienepermiso() {
        if (!this.recibo) {
          return false;
        }
        // window.console.log(this.recibo, this.$store.state.CARGO);
        return (
          this.recibo &&
          this.recibo.estado &&
          this.recibo.fecha_registro.substr(0, 7) === this.today.substr(0, 7) &&
          (this.$store.state.DATA_USER.id == this.recibo.emisor_id || this.$store.state.CARGO.id == 1) &&
          !this.recibo.factura_id
        );
      },
    },
    methods: {
      openDialogShow(recibo) {
        // this.$refs.refEditRecibo.showThisView(recibo, this.PlanPagos); //FIXME: In produccion remove this line
        this.recibo = recibo;
        this.$refs.refDetail.showThisView(recibo, this.PlanPagos); 
      },
      openEditReciboTable(recibo) {
        this.$refs.refEditReciboTable.showThisView(recibo, this.PlanPagos);
      },
      openEditDialog(recibo) {
        this.$refs.refDetail.closeDialog();
        this.$refs.refEditRecibo.showThisView(recibo, this.PlanPagos);
      },
      async cancelRecibo() {
        if (
          await this.$root.$confirm.open(
            'Estas seguro de anular recibo ?',
            'Los Datos del recibo será eliminado definitivamente y no podrá ser visualizado nuevamente',
            { color: 'orange', width: 400 },
          )
        ) {
          const url = `${this.api_rest}/api/pagos/recibos/id/${this.recibo.id}`;
          xaxios
            .delete(url)
            .then(() => {
              this.$root.$notify.show(`Recibo Anulado Exitosamente`, { color: 'primary' });
              this.$refs.refDetail.closeDialog();
            })
            .catch(() => {
              this.$root.$notify.show(`Error al Anular el Recibo`, { color: 'amber' });
            });
        }
      },
      eventCloseDialog() {
        this.$emit('closeDialog');
      },

      cortar(concepto){
        if(concepto.indexOf('-') > 0){
          let numero_cuota = concepto.split('-')[1].trim();
          let concepto_name = concepto.split('-')[0].trim();
          return {a:numero_cuota, b: concepto_name}
        }
        return {a:'?', b: concepto}
      },
    },
    destroyed() {
      this.recibos = [];
      this.recibo = null;
    },
    
    mounted() {
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;
      let vue = this;
      //   window.console.log(' date myRecibos.vue', this.today, this.today.substr(0, 7));

      this.plan_pagos = this.PlanPagos;
      // window.console.log('RecibosGenerados : ', JSON.stringify(this.RecibosGenerados));
      this.recibos = this.RecibosGenerados.map((item) => {
        item.total = 0;
        item.detalle = item.detalle
          ? item.detalle.map((detail) => {
              // window.console.log('--',detail);
              let c = vue.cortar(detail.concepto)
              item.total += detail.monto;
              detail.numero_cuota = c.a;
              detail.concepto_name = c.b;
              detail.plan_cuota = this.plan_pagos.find((pp) => pp.id === detail.cuota_id);
              return detail;
            })
          : [];
        return item;
      });
    },
  };
</script>
